import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonsModule } from '../../commons/commons.module';
import { ProcessContainerComponent } from './process-container/process-container.component';
import { ProcessStepContainerComponent } from './process-step-container/process-step-container.component';
import { ProcessStepItemComponent } from './process-step-item/process-step-item.component';
import { AppFrameComponent } from './app-frame/app-frame.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ButtonBarForSelectedServiceComponent } from './button-bar-for-selected-service/button-bar-for-selected-service.component';
import { SalonDetailsHeaderComponent } from './salon-details-header/salon-details-header.component';
import { NavigationBackButtonComponent } from './navigation-back-button/navigation-back-button.component';
import { SalonCardComponent } from './salon-card/salon-card.component';
import { CityCardComponent } from './city-card/city-card.component';
import { RatingStarIconComponent } from './rating-star-icon/rating-star-icon.component';
import { AgbToAcceptDialogComponent } from './agb-to-accept-dialog/agb-to-accept-dialog.component';
import { StaticContentOnlineBookingBenefitComponent } from './static-content-online-booking-benefit/static-content-online-booking-benefit.component';
import { StaticContentOnlineBookingProcessComponent } from './static-content-online-booking-process/static-content-online-booking-process.component';
import { StaticContentBecomePartnerComponent } from './static-content-become-partner/static-content-become-partner.component';
import { StaticContentDownloadAppComponent } from './static-content-download-app/static-content-download-app.component';
import { ContactUpdateDialogComponent } from './contact-update-dialog/contact-update-dialog.component';
import { CookiesDialogComponent } from './cookies-dialog/cookies-dialog.component';
import { LoadingSplashScreenDialogComponent } from './loading-splash-screen-dialog/loading-splash-screen-dialog.component';
import { SalonListCarouselComponent } from './salon-list-carousel/salon-list-carousel.component';
import { ButtonBarForContinueBookingComponent } from './button-bar-for-continue-booking/button-bar-for-continue-booking.component';
import { ImageFullsizeViewDialogComponent } from './image-fullsize-view-dialog/image-fullsize-view-dialog.component';
import { GoogleMapsEmbedIframeDialogComponent } from './google-maps-embed-iframe-dialog/google-maps-embed-iframe-dialog.component';
import {
  AgbFormComponent,
  CarouselModule,
  ContactDataFormComponent,
  PersonalDataFormComponent,
  PhoneNumberInputModule,
} from '@libs/index';
import { PinCodeInputModule, PasswordFormComponent } from '@libs/ui';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ProcessContainerComponent,
    ProcessStepContainerComponent,
    ProcessStepItemComponent,
    AppFrameComponent,
    HeaderComponent,
    FooterComponent,
    RatingStarIconComponent,
    ButtonBarForSelectedServiceComponent,
    SalonDetailsHeaderComponent,
    NavigationBackButtonComponent,
    SalonCardComponent,
    CityCardComponent,
    AgbToAcceptDialogComponent,
    StaticContentOnlineBookingBenefitComponent,
    StaticContentOnlineBookingProcessComponent,
    StaticContentBecomePartnerComponent,
    StaticContentDownloadAppComponent,
    ContactUpdateDialogComponent,
    CookiesDialogComponent,
    LoadingSplashScreenDialogComponent,
    SalonListCarouselComponent,
    ButtonBarForContinueBookingComponent,
    ImageFullsizeViewDialogComponent,
    GoogleMapsEmbedIframeDialogComponent,
  ],
  imports: [
    CommonModule,
    CommonsModule,
    AgbFormComponent,
    ContactDataFormComponent,
    PinCodeInputModule,
    PasswordFormComponent,
    PersonalDataFormComponent,
    PhoneNumberInputModule,
    CarouselModule.forRoot(),
    // material design
    MatBadgeModule,
    MatButtonModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatRippleModule,
    MatSidenavModule,
    MatSlideToggleModule,
  ],
  exports: [
    // modules + standalone component
    AgbFormComponent,
    CarouselModule,
    ContactDataFormComponent,
    PinCodeInputModule,
    PasswordFormComponent,
    PersonalDataFormComponent,
    PhoneNumberInputModule,
    // components
    ProcessContainerComponent,
    ProcessStepContainerComponent,
    AppFrameComponent,
    RatingStarIconComponent,
    ButtonBarForSelectedServiceComponent,
    SalonDetailsHeaderComponent,
    NavigationBackButtonComponent,
    SalonCardComponent,
    CityCardComponent,
    StaticContentOnlineBookingBenefitComponent,
    StaticContentOnlineBookingProcessComponent,
    StaticContentBecomePartnerComponent,
    StaticContentDownloadAppComponent,
    SalonListCarouselComponent,
    ButtonBarForContinueBookingComponent,
    ImageFullsizeViewDialogComponent,
    GoogleMapsEmbedIframeDialogComponent,
  ],
})
export class PagesComponentsModule {}
